import {
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    TextField,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import CloseIcon from "@material-ui/icons/Close";
import { EnumTipoBusquedaFolio } from "../../../../settings/enumConfig";
import { Fragment } from "react";
import MeditocModal from "../../../utils/MeditocModal";
import SearchIcon from "@material-ui/icons/Search";
import { useCallCenter } from "../../../../context/CallCenterContext";

export default function FormBuscarFolio() {
    const {
        folioEncontrado,
        modalOpenBuscarFolio,
        formBuscarFolio,
        handleOpenBuscarFolio,
        handleChangeFormBuscarFolioText,
        handleClickBuscarFolio,
        handleClickLimpiarBuscarFolio,
        handleClickIniciarConsultaFormBuscarFolio,
    } = useCallCenter();

    const {
        txtBuscarFolio,
        txtTipoBusqueda,
        txtBuscarNombrePaciente,
        txtBuscarTelefonoPaciente,
        txtBuscarCorreoPaciente,
    } = formBuscarFolio;

    return (
        <MeditocModal
            title="Iniciar consulta"
            open={modalOpenBuscarFolio}
            setopen={handleOpenBuscarFolio}
            okfunc={handleClickIniciarConsultaFormBuscarFolio}
            okDisabled={!folioEncontrado}
            okmessage="Iniciar consulta"
            size="small"
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography>{txtTipoBusqueda.label}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <RadioGroup
                        row
                        name="txtTipoBusqueda"
                        value={txtTipoBusqueda.value}
                        onChange={handleChangeFormBuscarFolioText}
                    >
                        <FormControlLabel control={<Radio />} label="Folio" value={EnumTipoBusquedaFolio.folio} />
                        <FormControlLabel
                            control={<Radio />}
                            label="Correo de usuario"
                            value={EnumTipoBusquedaFolio.usuario}
                        />
                    </RadioGroup>
                </Grid>
                <Grid item xs={12}>
                    <Typography>
                        {txtTipoBusqueda.value == EnumTipoBusquedaFolio.folio
                            ? "Ingrese un folio para iniciar la consulta:"
                            : "Ingrese el correo de usuario para iniciar la consulta:"}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtBuscarFolio"
                        label={
                            txtTipoBusqueda.value == EnumTipoBusquedaFolio.folio
                                ? txtBuscarFolio.label
                                : txtBuscarFolio.label2
                        }
                        required={txtBuscarFolio.required}
                        value={txtBuscarFolio.value}
                        error={txtBuscarFolio.error}
                        helperText={txtBuscarFolio.error && txtBuscarFolio.message}
                        onChange={handleChangeFormBuscarFolioText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment>
                                    <Tooltip
                                        title={
                                            txtTipoBusqueda.value == EnumTipoBusquedaFolio.folio
                                                ? "Buscar folio"
                                                : "Buscar usuario"
                                        }
                                        placement="top"
                                        arrow
                                    >
                                        <IconButton onClick={handleClickBuscarFolio} color="primary">
                                            <SearchIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Limpiar búsqueda" placement="top" arrow>
                                        <IconButton onClick={handleClickLimpiarBuscarFolio}>
                                            <CloseIcon className="color-4" />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                {folioEncontrado && (
                    <Fragment>
                        <Grid item xs={12}>
                            <Typography>Datos de paciente encontrados:</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="txtBuscarNombrePaciente"
                                label={txtBuscarNombrePaciente.label}
                                value={txtBuscarNombrePaciente.value}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="txtBuscarTelefonoPaciente"
                                label={txtBuscarTelefonoPaciente.label}
                                value={txtBuscarTelefonoPaciente.value}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="txtBuscarCorreoPaciente"
                                label={txtBuscarCorreoPaciente.label}
                                value={txtBuscarCorreoPaciente.value}
                                variant={inputVariant}
                                color={inputColor}
                                fullWidth
                                disabled
                            />
                        </Grid>
                    </Fragment>
                )}
            </Grid>
        </MeditocModal>
    );
}
